import { MedicalDataTypes, APITypes } from '../../../../../primary-record-types';

export const relatedResourcesMap: Record<
    APITypes.medicalProfileService.CareTeamMemberTypes,
    MedicalDataTypes.PrimaryRecordResourceCategory[]
> = {
    provider: ['medication', 'condition', 'allergy', 'visit'],
    insurance: ['visit'],
    support: ['visit'],
};
